// COMMONS
import TextField from '../components/Common/TextField';
import CoogTable from '../components/CoogTable/CoogTable';
import DashboardCard from '../components/DashboardCard/DashboardCard';
import DashboardCardQuotations from '../components/DashboardCardQuotations/DashboardCardQuotations';
import StepNavMenu from '../components/Menu/StepNav/StepNavMenu';
// Customers
// DLPK
import DlpkContactCard from '../components/Customers/Dlpk/ContactCard';
import DlpkDashboardCard from '../components/Customers/Dlpk/DashboardCard';
import DlpkInfoCard from '../components/Customers/Dlpk/InfoCard';
import ProjectPicker from '../components/ProjectPicker/ProjectPicker';
// import ProductExtra from '../components/ProductExtra/ProductExtra';
// QUOTATION components
import SchemaForm from '../components/SchemaForm/SchemaForm';
import OfferBlock from '../components/SchemaForm/Offer/OfferBlock';
import CoveredBlock from '../components/SchemaForm/Covered/CoveredBlock';
import ExtraBlock from '../components/SchemaForm/Extra/ExtraBlock';
import LoanBlock from '../components/SchemaForm/Loan/LoanBlock';
import TransformBlock from '../components/SchemaForm/Transform/TransformBlock';
import HiddenField from '../components/Common/HiddenField';
// SALESROUTE components
import OffersBlock from '../components/SalesRoute/OfferBlock/OfferBlock';
import QuestionnaireBlock from '../components/SalesRoute/QuestionnaireBlock/QuestionnaireBlock';
import MultipleQuestionnairesBlock from '../components/SalesRoute/MultipleQuestionnairesBlock/MultipleQuestionnairesBlock';
import QuotationBlock from '../components/SalesRoute/QuotationBlock/QuotationBlock';
import Header from '../components/SalesRoute/Header/Header';
import ExpansionPanelBlock from '../components/SalesRoute/ExpansionPanelBlock/ExpansionPanelBlock';
import SummaryBlock from '../components/SalesRoute/SummaryBlock/SummaryBlock';
import DocumentsBlock from '../components/SalesRoute/DocumentsBlock/DocumentsBlock';

import ProductDocuments from '../components/ProductDocuments/ProductDocuments';

export {
  DashboardCard,
  DashboardCardQuotations,
  ProjectPicker,
  CoogTable,
  TextField,
  StepNavMenu,
  DlpkContactCard,
  DlpkDashboardCard,
  DlpkInfoCard,
  // QUOTATION components
  SchemaForm,
  OfferBlock,
  CoveredBlock,
  ExtraBlock,
  LoanBlock,
  TransformBlock,
  HiddenField,
  // SALESROUTE components
  OffersBlock,
  QuestionnaireBlock,
  MultipleQuestionnairesBlock,
  QuotationBlock,
  Header,
  ProductDocuments,
  ExpansionPanelBlock,
  SummaryBlock,
  DocumentsBlock,
};

console.log('[LOADED]', `${NAME}@${VERSION}`); // eslint-disable-line
